import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import constants from "./constants"
import AxiosConfig from "./plugins/api"
import loadScript from 'vue-plugin-load-script';

Vue.use(loadScript);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.VUE_APP_DEVTOOLS
Vue.prototype.$axios = AxiosConfig
Vue.prototype.$constants = constants
store.$axios = AxiosConfig

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app');